module.exports = __webpack_public_path__ + "static/img/11.73dc2f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/11.png
// module id = NKPS
// module chunks = 0